import { FC } from 'react';
import { OwBannerImage } from '../../../interfaces/domain/ow-banner.modal';
import OWLink from '../../shared/ow-link';
// -----------------------------------------------------------------------------
interface BannersShelveItemProps {
  item: OwBannerImage;
}
// -----------------------------------------------------------------------------

const BannersShelveItem: FC<BannersShelveItemProps> = ({item}) => {

  return (
    <li className='game-item'>
      <OWLink href={item.link} title={item.title}>
        <img src={item.imgUrl} alt={item.title} />
      </OWLink>
    </li>
  );
};

export default BannersShelveItem;